<template>
    <!-- wrap -->
    <div id="wrap">
        <!-- header -->
        <div id="header">
            <div class="container">
                <div class="header-top">
                    <div class="back">
                        <a @click="backbtn"><i /><span class="blind">뒤로가기</span></a>
                        <span class="header-sub">( TBM ) </span><span> 페이스매핑 상세</span>
                    </div>

                    <div class="header-nav">
                        <a class="btn btn-home" @click="home"><i /><span class="blind">홈으로</span></a>
                    </div>
                </div>
            </div>
        </div>
        <!-- // header -->

        <!-- content-wrap -->
        <main id="content-wrap">
            <div id="contents">
                <div class="detail-wrapper">
                    <div class="detail-box" :class="{ close: isCloseA }">
                        <div class="detail-header">
                            <a class="view" :class="{ close: isCloseA }" @click="isCloseA = !isCloseA"
                                ><span>Tunneling Face Mapping Note</span></a
                            >
                        </div>
                        <div class="detail-contents">
                            <ul class="fms-note">
                                <li>
                                    <span>Const. Name</span>
                                    <span>{{ data.constructionNameValue }}</span>
                                </li>
                                <li>
                                    <span>Geologist</span>
                                    <span>{{ data.geologist }}</span>
                                </li>
                                <li>
                                    <span>Checklist</span>
                                    <span>-</span>
                                </li>
                                <li>
                                    <span>Location</span>
                                    <span>{{ data.measureLocationName }}{{ data.measurePosition }}</span>
                                </li>
                                <li>
                                    <span>Date</span>
                                    <span>{{ data.investigationDay }} {{ data.investigationTime }}</span>
                                </li>
                                <li>
                                    <span>Station</span>
                                    <span>{{ data.station }}</span>
                                </li>
                                <li>
                                    <span>Excavation(Total)</span>
                                    <span>{{ data.excavation }} (총 {{ data.excavationTotal }} m)</span>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="detail-box" :class="{ close: isCloseC }">
                        <div class="detail-header">
                            <a class="view" :class="{ close: isCloseC }" @click="isCloseC = !isCloseC"
                                ><span>RMR Score Data Sheet</span></a
                            >
                        </div>
                        <div class="detail-contents">
                            <ul class="fms-note">
                                <li>
                                    <span>TYPE of Work</span>
                                    <span>{{ data.measureLocationName }}</span>
                                </li>
                                <li>
                                    <span>Station</span>
                                    <span>STA NO. {{ data.station }}</span>
                                </li>
                                <li>
                                    <span>Date</span>
                                    <span>{{ data.investigationDay }} {{ data.investigationTime }}</span>
                                </li>
                                <li>
                                    <span>Geologist</span>
                                    <span>{{ data.geologist }}</span>
                                </li>
                                <li>
                                    <span>Rock Type</span>
                                    <span>{{ data.rockTypeName }}</span>
                                </li>
                            </ul>

                            <div class="detail-subheader">
                                <h3>
                                    1. Rock Name <span class="val">{{ faceMappingStrength.rockNameValue }}</span>
                                </h3>
                            </div>

                            <div class="detail-subheader">
                                <h3>
                                    2. Strength of intact rock material(㎏/㎈)
                                    <span class="val">{{ faceMappingStrength.strengthIntackRockMaterialScore }}</span>
                                </h3>
                                <table class="type-simple">
                                    <thead>
                                        <tr>
                                            <th>>250</th>
                                            <th>~100</th>
                                            <th>~50</th>
                                            <th>~25</th>
                                            <th>~5</th>
                                            <th>~1</th>
                                            <th>&lt;1</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>15</td>
                                            <td>12</td>
                                            <td>7</td>
                                            <td>4</td>
                                            <td>2</td>
                                            <td>1</td>
                                            <td>0</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div class="detail-subheader">
                                <h3>
                                    3. R.Q.D(%) <span class="val">{{ faceMappingStrength.rqdScore }}</span>
                                </h3>
                                <table class="type-simple">
                                    <thead>
                                        <tr>
                                            <th>90~100</th>
                                            <th>90~95</th>
                                            <th>75~50</th>
                                            <th>50~25</th>
                                            <th>&lt;25</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>15</td>
                                            <td>12</td>
                                            <td>7</td>
                                            <td>4</td>
                                            <td>2</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div class="detail-subheader">
                                <h3>
                                    4. Sracing of Joint
                                    <span class="val">{{ faceMappingStrength.spacingJoinScore }}</span>
                                </h3>
                                <table class="type-1">
                                    <colgroup>
                                        <col style="width: 34.55%" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th>구분</th>
                                            <th>J1</th>
                                            <th>J2</th>
                                            <th>J3</th>
                                            <th>J4</th>
                                            <th>J5</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>>20m <span class="sm">(20)</span></td>
                                            <td>
                                                <div v-if="faceMappingSection.J1_spacingJoint_2m" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J2_spacingJoint_2m" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J3_spacingJoint_2m" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J4_spacingJoint_2m" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.Ran_spacingJoint_2m" class="on" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>0.6-2m <span class="sm">(15)</span></td>
                                            <td>
                                                <div v-if="faceMappingSection.J1_spacingJoint_062m" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J2_spacingJoint_06_2m" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J3_spacingJoint_06_2m" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J4_spacingJoint_06_2m" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.Ran_spacingJoint_06_2m" class="on" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>200-600m <span class="sm">(10)</span></td>
                                            <td>
                                                <div v-if="faceMappingSection.J1_spacingJoint_200_600mm" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J2_spacingJoint_200_600mm" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J3_spacingJoint_200_600mm" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J4_spacingJoint_200_600mm" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.Ran_spacingJoint_200_600mm" class="on" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>60-200mm <span class="sm">(8)</span></td>
                                            <td>
                                                <div v-if="faceMappingSection.J1_spacingJoint_60_200mm" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J2_spacingJoint_60_200mm" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J3_spacingJoint_60_200mm" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J4_spacingJoint_60_200mm" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.Ran_spacingJoint_60_200mm" class="on" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>&lt;60mm <span class="sm">(6)</span></td>
                                            <td>
                                                <div v-if="faceMappingSection.J1_spacingJoint_60mm" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J2_spacingJoint_60mm" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J3_spacingJoint_60mm" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J4_spacingJoint_60mm" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.Ran_spacingJoint_60mm" class="on" />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div class="detail-subheader">
                                <h3>
                                    5. Condition of Joint
                                    <span class="val">{{ faceMappingStrength.conditionJoinScore }}</span>
                                </h3>
                                <table class="type-1">
                                    <colgroup>
                                        <col style="width: 47.64%" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th>Persistence</th>
                                            <th>J1</th>
                                            <th>J2</th>
                                            <th>J3</th>
                                            <th>J4</th>
                                            <th>Ran</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>&lt;1m <span class="sm">(6)</span></td>
                                            <td>
                                                <div v-if="faceMappingSection.J1_persitence_1m" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J2_persitence_1m" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J3_persitence_1m" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J4_persitence_1m" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.Ran_persitence_1m" class="on" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>1-3m <span class="sm">(4)</span></td>
                                            <td>
                                                <div v-if="faceMappingSection.J1_persitence_1_3m" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J2_persitence_1_3m" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J3_persitence_1_3m" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J4_persitence_1_3m" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.Ran_persitence_1_3m" class="on" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>3-10m <span class="sm">(2)</span></td>
                                            <td>
                                                <div v-if="faceMappingSection.J1_persitence_3_10m" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J2_persitence_3_10m" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J3_persitence_3_10m" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J4_persitence_3_10m" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.Ran_persitence_3_10m" class="on" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>10-20m <span class="sm">(1)</span></td>
                                            <td>
                                                <div v-if="faceMappingSection.J1_persitence_10_20m" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J2_persitence_10_20m" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J3_persitence_10_20m" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J4_persitence_10_20m" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.Ran_persitence_10_20m" class="on" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>&gt;20mm <span class="sm">(0)</span></td>
                                            <td>
                                                <div v-if="faceMappingSection.J1_persitence_20m" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J2_persitence_20m" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J3_persitence_20m" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J4_persitence_20m" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.Ran_persitence_20m" class="on" />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table class="type-1">
                                    <colgroup>
                                        <col style="width: 47.64%" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th>Aperture</th>
                                            <th>J1</th>
                                            <th>J2</th>
                                            <th>J3</th>
                                            <th>J4</th>
                                            <th>Ran</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>None <span class="sm">(6)</span></td>
                                            <td>
                                                <div v-if="faceMappingSection.J1_aperture_None" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J2_aperture_None" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J3_aperture_None" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J4_aperture_None" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.Ran_aperture_None" class="on" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>&lt;0.1mm <span class="sm">(5)</span></td>
                                            <td>
                                                <div v-if="faceMappingSection.J1_aperture_01mm" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J2_aperture_01mm" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J3_aperture_01mm" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J4_aperture_01mm" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.Ran_aperture_01mm" class="on" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>0.1m-1mm <span class="sm">(4)</span></td>
                                            <td>
                                                <div v-if="faceMappingSection.J1_aperture_01_1mm" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J2_aperture_01_1mm" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J3_aperture_01_1mm" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J4_aperture_01_1mm" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.Ran_aperture_01_1mm" class="on" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>1-5m <span class="sm">(1)</span></td>
                                            <td>
                                                <div v-if="faceMappingSection.J1_aperture_1_5mm" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J2_aperture_1_5mm" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J3_aperture_1_5mm" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J4_aperture_1_5mm" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.Ran_aperture_1_5mm" class="on" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>&gt;5mm <span class="sm">(0)</span></td>
                                            <td>
                                                <div v-if="faceMappingSection.J1_aperture_5mm" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J2_aperture_5mm" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J3_aperture_5mm" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J4_aperture_5mm" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.Ran_aperture_5mm" class="on" />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table class="type-1">
                                    <colgroup>
                                        <col style="width: 47.64%" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th>Roughness</th>
                                            <th>J1</th>
                                            <th>J2</th>
                                            <th>J3</th>
                                            <th>J4</th>
                                            <th>Ran</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Very rough <span class="sm">(6)</span></td>
                                            <td>
                                                <div v-if="faceMappingSection.J1_roughness_Very_rough" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J2_roughness_Very_rough" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J3_roughness_Very_rough" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J4_roughness_Very_rough" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.Ran_roughness_Very_rough" class="on" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>rough <span class="sm">(5)</span></td>
                                            <td>
                                                <div v-if="faceMappingSection.J1_roughness_rough" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J2_roughness_rough" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J3_roughness_rough" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J4_roughness_rough" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.Ran_roughness_rough" class="on" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>slightly rough <span class="sm">(3)</span></td>
                                            <td>
                                                <div v-if="faceMappingSection.J1_roughness_slightly_rough" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J2_roughness_slightly_rough" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J3_roughness_slightly_rough" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J4_roughness_slightly_rough" class="on" />
                                            </td>
                                            <td>
                                                <div
                                                    v-if="faceMappingSection.Ran_roughness_slightly_rough"
                                                    class="on"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Smooth <span class="sm">(1)</span></td>
                                            <td>
                                                <div v-if="faceMappingSection.J1_roughness_Smooth" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J2_roughness_Smooth" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J3_roughness_Smooth" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J4_roughness_Smooth" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.Ran_roughness_Smooth" class="on" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>slickenside <span class="sm">(0)</span></td>
                                            <td>
                                                <div v-if="faceMappingSection.J1_roughness_slickenside" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J2_roughness_slickenside" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J3_roughness_slickenside" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J4_roughness_slickenside" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.Ran_roughness_slickenside" class="on" />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table class="type-1">
                                    <colgroup>
                                        <col style="width: 47.64%" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th>In-Filling</th>
                                            <th>J1</th>
                                            <th>J2</th>
                                            <th>J3</th>
                                            <th>J4</th>
                                            <th>Ran</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>None <span class="sm">(6)</span></td>
                                            <td>
                                                <div v-if="faceMappingSection.J1_inFilling_None" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J2_inFilling_None" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J3_inFilling_None" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J4_inFilling_None" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.Ran_inFilling_None" class="on" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Hardfilling < 5mm <span class="sm">(4)</span></td>
                                            <td>
                                                <div
                                                    v-if="faceMappingSection.J1_inFilling_hardfilling_5mm_below"
                                                    class="on"
                                                />
                                            </td>
                                            <td>
                                                <div
                                                    v-if="faceMappingSection.J2_inFilling_hardfilling_5mm_below"
                                                    class="on"
                                                />
                                            </td>
                                            <td>
                                                <div
                                                    v-if="faceMappingSection.J3_inFilling_hardfilling_5mm_below"
                                                    class="on"
                                                />
                                            </td>
                                            <td>
                                                <div
                                                    v-if="faceMappingSection.J4_inFilling_hardfilling_5mm_below"
                                                    class="on"
                                                />
                                            </td>
                                            <td>
                                                <div
                                                    v-if="faceMappingSection.Ran_inFilling_hardfilling_5mm_below"
                                                    class="on"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Hardfilling > 5mm <span class="sm">(2)</span></td>
                                            <td>
                                                <div
                                                    v-if="faceMappingSection.J1_inFilling_hardfilling_5mm_more"
                                                    class="on"
                                                />
                                            </td>
                                            <td>
                                                <div
                                                    v-if="faceMappingSection.J2_inFilling_hardfilling_5mm_more"
                                                    class="on"
                                                />
                                            </td>
                                            <td>
                                                <div
                                                    v-if="faceMappingSection.J3_inFilling_hardfilling_5mm_more"
                                                    class="on"
                                                />
                                            </td>
                                            <td>
                                                <div
                                                    v-if="faceMappingSection.J4_inFilling_hardfilling_5mm_more"
                                                    class="on"
                                                />
                                            </td>
                                            <td>
                                                <div
                                                    v-if="faceMappingSection.Ran_inFilling_hardfilling_5mm_more"
                                                    class="on"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Softfilling > 5mm <span class="sm">(2)</span></td>
                                            <td>
                                                <div
                                                    v-if="faceMappingSection.J1_inFilling_softfilling_5mm_below"
                                                    class="on"
                                                />
                                            </td>
                                            <td>
                                                <div
                                                    v-if="faceMappingSection.J2_inFilling_softfilling_5mm_below"
                                                    class="on"
                                                />
                                            </td>
                                            <td>
                                                <div
                                                    v-if="faceMappingSection.J3_inFilling_softfilling_5mm_below"
                                                    class="on"
                                                />
                                            </td>
                                            <td>
                                                <div
                                                    v-if="faceMappingSection.J4_inFilling_softfilling_5mm_below"
                                                    class="on"
                                                />
                                            </td>
                                            <td>
                                                <div
                                                    v-if="faceMappingSection.Ran_inFilling_softfilling_5mm_below"
                                                    class="on"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Softfilling > 5mm <span class="sm">(0)</span></td>
                                            <td>
                                                <div
                                                    v-if="faceMappingSection.J1_inFilling_softfilling_5mm_more"
                                                    class="on"
                                                />
                                            </td>
                                            <td>
                                                <div
                                                    v-if="faceMappingSection.J2_inFilling_softfilling_5mm_more"
                                                    class="on"
                                                />
                                            </td>
                                            <td>
                                                <div
                                                    v-if="faceMappingSection.J3_inFilling_softfilling_5mm_more"
                                                    class="on"
                                                />
                                            </td>
                                            <td>
                                                <div
                                                    v-if="faceMappingSection.J4_inFilling_softfilling_5mm_more"
                                                    class="on"
                                                />
                                            </td>
                                            <td>
                                                <div
                                                    v-if="faceMappingSection.Ran_inFilling_softfilling_5mm_more"
                                                    class="on"
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table class="type-1">
                                    <colgroup>
                                        <col style="width: 47.64%" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th>Wall strength</th>
                                            <th>J1</th>
                                            <th>J2</th>
                                            <th>J3</th>
                                            <th>J4</th>
                                            <th>Ran</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>unweathered <span class="sm">(6)</span></td>
                                            <td>
                                                <div v-if="faceMappingSection.J1_wallStrength_unweathered" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J2_wallStrength_unweathered" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J3_wallStrength_unweathered" class="on" />
                                            </td>
                                            <td>
                                                <div v-if="faceMappingSection.J4_wallStrength_unweathered" class="on" />
                                            </td>
                                            <td>
                                                <div
                                                    v-if="faceMappingSection.Ran_wallStrength_unweathered"
                                                    class="on"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>slightly weathered <span class="sm">(5)</span></td>
                                            <td>
                                                <div
                                                    v-if="faceMappingSection.J1_wallStrength_slightly_weathered"
                                                    class="on"
                                                />
                                            </td>
                                            <td>
                                                <div
                                                    v-if="faceMappingSection.J2_wallStrength_slightly_weathered"
                                                    class="on"
                                                />
                                            </td>
                                            <td>
                                                <div
                                                    v-if="faceMappingSection.J3_wallStrength_slightly_weathered"
                                                    class="on"
                                                />
                                            </td>
                                            <td>
                                                <div
                                                    v-if="faceMappingSection.J4_wallStrength_slightly_weathered"
                                                    class="on"
                                                />
                                            </td>
                                            <td>
                                                <div
                                                    v-if="faceMappingSection.Ran_wallStrength_slightly_weathered"
                                                    class="on"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>moderately weathered <span class="sm">(3)</span></td>
                                            <td>
                                                <div
                                                    v-if="faceMappingSection.J1_wallStrength_moderately_weathered"
                                                    class="on"
                                                />
                                            </td>
                                            <td>
                                                <div
                                                    v-if="faceMappingSection.J2_wallStrength_moderately_weathered"
                                                    class="on"
                                                />
                                            </td>
                                            <td>
                                                <div
                                                    v-if="faceMappingSection.J3_wallStrength_moderately_weathered"
                                                    class="on"
                                                />
                                            </td>
                                            <td>
                                                <div
                                                    v-if="faceMappingSection.J4_wallStrength_moderately_weathered"
                                                    class="on"
                                                />
                                            </td>
                                            <td>
                                                <div
                                                    v-if="faceMappingSection.Ran_wallStrength_moderately_weathered"
                                                    class="on"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>highly weathered <span class="sm">(1)</span></td>
                                            <td>
                                                <div
                                                    v-if="faceMappingSection.J1_wallStrength_highly_weathered"
                                                    class="on"
                                                />
                                            </td>
                                            <td>
                                                <div
                                                    v-if="faceMappingSection.J2_wallStrength_highly_weathered"
                                                    class="on"
                                                />
                                            </td>
                                            <td>
                                                <div
                                                    v-if="faceMappingSection.J3_wallStrength_highly_weathered"
                                                    class="on"
                                                />
                                            </td>
                                            <td>
                                                <div
                                                    v-if="faceMappingSection.J4_wallStrength_highly_weathered"
                                                    class="on"
                                                />
                                            </td>
                                            <td>
                                                <div
                                                    v-if="faceMappingSection.Ran_wallStrength_highly_weathered"
                                                    class="on"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>completely weathered <span class="sm">(0)</span></td>
                                            <td>
                                                <div
                                                    v-if="faceMappingSection.J1_wallStrength_completely_weathered"
                                                    class="on"
                                                />
                                            </td>
                                            <td>
                                                <div
                                                    v-if="faceMappingSection.J2_wallStrength_completely_weathered"
                                                    class="on"
                                                />
                                            </td>
                                            <td>
                                                <div
                                                    v-if="faceMappingSection.J3_wallStrength_completely_weathered"
                                                    class="on"
                                                />
                                            </td>
                                            <td>
                                                <div
                                                    v-if="faceMappingSection.J4_wallStrength_completely_weathered"
                                                    class="on"
                                                />
                                            </td>
                                            <td>
                                                <div
                                                    v-if="faceMappingSection.Ran_wallStrength_completely_weathered"
                                                    class="on"
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div class="detail-subheader">
                                <h3>
                                    6. Ground water Ratio<span class="val">{{
                                        faceMappingStrength.groundWaterRatioScore
                                    }}</span>
                                </h3>

                                <table class="type-1">
                                    <colgroup>
                                        <col style="width: 22.79%" />
                                        <col style="width: 33.08%" />
                                        <col style="width: auto" />
                                        <col style="width: auto" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th>Condition</th>
                                            <th>Inflow per 10m<br />tunnel length</th>
                                            <th>Condition</th>
                                            <th>Rating</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Dry</td>
                                            <td>-</td>
                                            <td>15</td>
                                            <td>
                                                <div v-if="groundWaterRatio.groundWaterRatio_dry" class="on" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Damp</td>
                                            <td>
                                                &lt;10
                                            </td>
                                            <td>10</td>
                                            <td>
                                                <div v-if="groundWaterRatio.groundWaterRatio_damp" class="on" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Wet</td>
                                            <td>10~25</td>
                                            <td>7</td>
                                            <td>
                                                <div v-if="groundWaterRatio.groundWaterRatio_wet" class="on" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Dripping</td>
                                            <td>25~125</td>
                                            <td>4</td>
                                            <td>
                                                <div v-if="groundWaterRatio.groundWaterRatio_dripping" class="on" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Flowing</td>
                                            <td>>125</td>
                                            <td>0</td>
                                            <td>
                                                <div v-if="groundWaterRatio.groundWaterRatio_flowing" class="on" />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div class="detail-subheader">
                                <h3>
                                    7. Ratio of adjustment for joint orientation
                                    <span class="val">{{ faceMappingStrength.orientationScore }}</span>
                                </h3>

                                <table class="type-1">
                                    <colgroup>
                                        <col style="width: 40.44%" />
                                        <col style="width: 40%" />
                                        <col style="width: auto" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th>구분</th>
                                            <th>Operation</th>
                                            <th>Rating</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Joint1</td>
                                            <td>
                                                <span class="txt">{{ faceMappingStrength.orientationJoint1 }}</span>
                                            </td>
                                            <td>
                                                <span class="txt">{{
                                                    faceMappingStrength.orientationJoint1Rating
                                                }}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Joint2</td>
                                            <td>
                                                <span class="txt">{{ faceMappingStrength.orientationJoint2 }}</span>
                                            </td>
                                            <td>
                                                <span class="txt">{{
                                                    faceMappingStrength.orientationJoint2Rating
                                                }}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Joint3</td>
                                            <td>
                                                <span class="txt">{{ faceMappingStrength.orientationJoint3 }}</span>
                                            </td>
                                            <td>
                                                <span class="txt">{{
                                                    faceMappingStrength.orientationJoint3Rating
                                                }}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Joint4</td>
                                            <td>
                                                <span class="txt">{{ faceMappingStrength.orientationJoint4 }}</span>
                                            </td>
                                            <td>
                                                <span class="txt">{{
                                                    faceMappingStrength.orientationJoint4Rating
                                                }}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Random Joint</td>
                                            <td>
                                                <span class="txt">{{
                                                    faceMappingStrength.orientationRandomJoint
                                                }}</span>
                                            </td>
                                            <td>
                                                <span class="txt">{{
                                                    faceMappingStrength.orientationRandomJointRating
                                                }}</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table class="type-2">
                                    <colgroup>
                                        <col style="width: 40.44%" />
                                        <col style="width:auto" />
                                    </colgroup>
                                    <tr>
                                        <th class="tit">
                                            Very Favourable
                                        </th>
                                        <td>0</td>
                                    </tr>
                                    <tr>
                                        <th class="tit">
                                            Favourable
                                        </th>
                                        <td>-2</td>
                                    </tr>
                                    <tr>
                                        <th class="tit">
                                            Fair
                                        </th>
                                        <td>-5</td>
                                    </tr>
                                    <tr>
                                        <th class="tit">
                                            Unfavourable
                                        </th>
                                        <td>-10</td>
                                    </tr>
                                    <tr>
                                        <th class="tit">
                                            Very Unfavourable
                                        </th>
                                        <td>-12</td>
                                    </tr>
                                    <tr>
                                        <th colspan="2" class="contrast-light">
                                            Strike perpendicular to tunnel axis
                                        </th>
                                    </tr>
                                    <tr>
                                        <th class="contrast-light">
                                            Very Favourable
                                        </th>
                                        <td>Drive with dip 45~90℃</td>
                                    </tr>
                                    <tr>
                                        <th class="contrast-light">
                                            Favourable
                                        </th>
                                        <td>Drive with dip 20~45℃</td>
                                    </tr>
                                    <tr>
                                        <th class="contrast-light">
                                            Fair
                                        </th>
                                        <td>Drive against dip-Dip 45~90℃</td>
                                    </tr>
                                    <tr>
                                        <th class="contrast-light">
                                            Unfavourable
                                        </th>
                                        <td>Drive against dip-Dip 20~45℃</td>
                                    </tr>
                                    <tr>
                                        <th colspan="2" class="contrast-light">
                                            Strike parallel to tunnel axis
                                        </th>
                                    </tr>
                                    <tr>
                                        <th class="contrast-light">
                                            Very unfavourable
                                        </th>
                                        <td>Dip 45~90℃</td>
                                    </tr>
                                    <tr>
                                        <th class="contrast-light">
                                            Fair
                                        </th>
                                        <td>Dip 20~45℃</td>
                                    </tr>
                                    <tr>
                                        <th class="contrast-light">
                                            Fair
                                        </th>
                                        <td>Dip 0~20℃ ~ irrespective of strike</td>
                                    </tr>
                                </table>
                            </div>

                            <div class="detail-subheader">
                                <h3>8. RMR Score</h3>
                                <p class="rmr-score">
                                    {{ rmr }}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="detail-box" :class="{ close: isCloseB }">
                        <div class="detail-header">
                            <a class="view" :class="{ close: isCloseB }" @click="isCloseB = !isCloseB"
                                ><span>막장 사진대지</span><span>#비상방류터널 STA No.0 + 855.0</span></a
                            >
                        </div>
                        <div class="detail-contents">
                            <div class="photo-list-wrapper">
                                <div class="photo-list-box">
                                    <p class="tit">
                                        좌측면
                                    </p>
                                    <div class="photo-inbox-wrapper">
                                        <div class="photo-inbox ratio-type-1">
                                            <div v-if="data.tbmLeftImageUrl" class="photo-img">
                                                <img
                                                    v-gallery:detail
                                                    :src="data.tbmLeftImageUrl"
                                                    :alt="data.tbmLeftImageUrl"
                                                />
                                            </div>
                                            <div v-else class="detail-noImg-box">
                                                사진없음
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="photo-list-box">
                                    <p class="tit">
                                        우측면
                                    </p>
                                    <div class="photo-inbox-wrapper">
                                        <div class="photo-inbox ratio-type-1">
                                            <div v-if="data.tbmRightImageUrl" class="photo-img height">
                                                <img :src="data.tbmRightImageUrl" :alt="data.tbmRightImageUrl" />
                                            </div>
                                            <div v-else class="detail-noImg-box">
                                                사진없음
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
        <!-- // content-wrap -->
    </div>
    <!-- // wrap -->
</template>

<script>
import { mapActions, mapState } from 'vuex';
import FacemappingApi from '../../api/FacemappingApi';
export default {
    name: 'DetailTBM',
    components: {},
    data: () => {
        return {
            id: null,
            data: {},
            faceMappingSection: {},
            faceMappingStrength: {},
            groundWaterRatio: {},
            rmr: 0,

            isCloseA: false,
            isCloseB: false
        };
    },
    computed: {
        ...mapState({})
    },
    beforeCreate() {
        ///////////////////////
        // Initializer Area
        ///////////////////////
        //this.showLoading();
        //this.$store.dispatch('showLoading');
    },
    created() {
        this.id = this.$route.params.id;
    },
    mounted() {
        this.dataObj();
    },
    beforeDestroy() {},
    methods: {
        ...mapActions(['showLoading', 'hideLoading']),
        backbtn() {
            this.$router.go(-1);
        },
        home() {
            this.$router.push({
                name: 'Main'
            });
        },
        dataObj() {
            this.showLoading();
            FacemappingApi.detail(this.id).then(res => {
                this.data = res.content;
                var strengthData = res.content.faceMappingStrength;
                var sectionList = res.content.faceMappingSectionList;
                var sectionTempObj = {};
                $.each(sectionList, function(index) {
                    var sectionDivisionCd = this.id.sectionDivisionCd;
                    $.each(this, function(k, v) {
                        if (k != 'id') {
                            v = v == null ? v : v.replace('-', '_').replace('㎜', 'mm'); // key값에 '-' 설정이 안되서 바꿈
                            sectionTempObj[sectionDivisionCd + '_' + k + '_' + v] = true;
                        }
                    });
                });
                this.faceMappingSection = sectionTempObj;

                if (strengthData != null) {
                    this.faceMappingStrength = strengthData;

                    var groundWaterRatioData = res.content.faceMappingStrength.groundWaterRatio;
                    if (groundWaterRatioData != null) {
                        var groundWaterRatioList = groundWaterRatioData.split(',');
                        var groundWaterRatioTempObj = {};
                        $.each(groundWaterRatioList, function() {
                            groundWaterRatioTempObj['groundWaterRatio_' + this] = true;
                        });
                        this.groundWaterRatio = groundWaterRatioTempObj;
                    }

                    var conditionJoinScore =
                        strengthData.conditionJoinScore == null ? 0 : strengthData.conditionJoinScore;
                    var groundWaterRatioScore =
                        strengthData.groundWaterRatioScore == null ? 0 : strengthData.groundWaterRatioScore;
                    var orientationScore = strengthData.orientationScore == null ? 0 : strengthData.orientationScore;
                    var rqdScore = strengthData.rqdScore == null ? 0 : strengthData.rqdScore;
                    var spacingJoinScore = strengthData.spacingJoinScore == null ? 0 : strengthData.spacingJoinScore;
                    var strengthIntackRockMaterialScore =
                        strengthData.strengthIntackRockMaterialScore == null
                            ? 0
                            : strengthData.strengthIntackRockMaterialScore;
                    var rmr =
                        Number(conditionJoinScore) +
                        Number(groundWaterRatioScore) +
                        Number(orientationScore) +
                        Number(rqdScore) +
                        Number(spacingJoinScore) +
                        Number(strengthIntackRockMaterialScore);

                    this.rmr = Math.floor(rmr * 10) / 10;
                } else {
                    this.rmr = 0;
                }

                this.hideLoading();
            });
        }
    }
};
/*
#wrap > div {
    height: inherit;
}
*/
</script>
